import {
  NotificationOptions,
  showNotification,
} from 'redux/modules/notification/actions';
import { ThunkAction } from 'redux/types';
import dayjs from 'utils/dayjs';

export interface ShowPostSuccessNotificationOptions {
  title?: string;
  message?: string;
  linkLabel?: string;
  sharePostUrl?: string;
}

export interface ShowPostErrorNotificationOptions {
  title?: string;
}

const DEFAULT_POST_SUCCESS_MESSAGE = 'You can see your post {{link}}';
const DEFAULT_POST_SUCCESS_TITLE = 'Your video was posted';
const DEFAULT_POST_SUCCESS_LINK_LABEL = 'here';

const DEFAULT_SCHEDULE_SUCCESS_TITLE = 'Your video was scheduled';
const DEFAULT_SCHEDULE_DATE_FORMAT = 'MMM D YYYY h:mm A';

const DEFAULT_POST_ERROR_OPTIONS: NotificationOptions = {
  message: 'Please try again or {{link}} so we can help',
  code: 'ER013' as const,
  level: 'error' as const,
  type: 'help' as const,
  title: "Sorry, we couldn't post your video",
  actionLabel: 'contact us',
};

export const showPostSuccessNotification = (
  options: ShowPostSuccessNotificationOptions,
): ThunkAction<void> => dispatch => {
  dispatch(
    showNotification(
      options.message ?? DEFAULT_POST_SUCCESS_MESSAGE,
      'success',
      0,
      'link',
      options.title ?? DEFAULT_POST_SUCCESS_TITLE,
      undefined,
      options.sharePostUrl,
      options.linkLabel ?? DEFAULT_POST_SUCCESS_LINK_LABEL,
    ),
  );
};

export const showScheduleSuccessNotification = (
  scheduledForMillis: number,
): ThunkAction<void> => dispatch => {
  const formattedDate = dayjs(scheduledForMillis).format(
    DEFAULT_SCHEDULE_DATE_FORMAT,
  );

  dispatch(
    showNotification({
      title: DEFAULT_SCHEDULE_SUCCESS_TITLE,
      message: `Scheduled for ${formattedDate}`,
      level: 'success',
    }),
  );
};

export const showPostErrorNotification = (
  options: ShowPostErrorNotificationOptions = {},
): ThunkAction<void> => dispatch =>
  dispatch(
    showNotification({
      ...DEFAULT_POST_ERROR_OPTIONS,
      ...options,
    }),
  );
